import { Box, Modal, Divider } from "@mui/material";
import ButtonComponent from "../Inputs/ButtonComponent";
import "../../CSS/ComponentCSS/BodySizeModal.css";
import TextComponent from "../Inputs/TextComponent";
import { Typography } from "antd";
import { ArrowForwardIos } from "@mui/icons-material";
import { useEffect, useState } from "react";
import AlertComponent from "../Alert/AlertComponent";
import Loading from "../LoadingBar/Loading";
import Api from "../../API/api";

type BodySizeModalProps = {
  open: boolean;
  onClose: (value: any) => void;
  state: string;
  sex: string;
  p_id: number;
  cancel?: boolean;
};

const { Title } = Typography;

export default function BodySizeModal(props: BodySizeModalProps) {
  const [bodyData, setBodyData] = useState({
    sex: props.sex == "Women" ? "F" : "M",
    height: 0,
    shoulder: 0,
    chest: 0,
    waist: 0,
    hip: 0,
    arm: 0,
    leg: 0,
  });
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [calculate, setCalculate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [BodyResult, setBodyResult] = useState({
    arm: "N",
    chest: 0,
    gender: "F",
    hip: 0,
    leg: "N",
    p_id: 0,
    shoulder: 0,
    type1: "",
    type2: "",
    waist: 0,
  });

  useEffect(() => {
    if (props.p_id != 0) {
      const getResult = async () => {
        setLoading(true);
        const Body = await Api.get(`/Consult/getBodyResult?p_id=${props.p_id}`);
        setLoading(false);
        if (Body != undefined) {
          setBodyResult(Body[0]);
        }
      };

      getResult();
    }
  }, []);

  const handlecalculate = () => {
    if (
      bodyData.height == 0 ||
      bodyData.shoulder == 0 ||
      bodyData.chest == 0 ||
      bodyData.waist == 0 ||
      bodyData.hip == 0 ||
      bodyData.arm == 0 ||
      bodyData.leg == 0
    ) {
      setAlert(true);
      setAlertMessage("모든 값을 채워주세요.");
      return;
    }

    if (bodyData.sex == "F") {
      if (
        bodyData.height < 145 ||
        bodyData.height >= 180 ||
        bodyData.shoulder < 13 ||
        bodyData.shoulder >= 19.75 ||
        bodyData.chest < 29 ||
        bodyData.chest >= 44.5 ||
        bodyData.waist < 22 ||
        bodyData.waist >= 37.5 ||
        bodyData.hip < 32 ||
        bodyData.hip >= 47.5 ||
        bodyData.arm < 19 ||
        bodyData.arm >= 26 ||
        bodyData.leg < 25.5 ||
        bodyData.leg >= 32.5
      ) {
        setAlert(true);
        setAlertMessage("유효범위를 입력해주세요.");
        return;
      }
    }

    if (bodyData.sex == "M") {
      if (
        bodyData.height < 160 ||
        bodyData.height >= 195 ||
        bodyData.shoulder < 15.25 ||
        bodyData.shoulder >= 20.25 ||
        bodyData.chest < 31 ||
        bodyData.chest >= 45 ||
        bodyData.waist < 25 ||
        bodyData.waist >= 39.5 ||
        bodyData.hip < 31 ||
        bodyData.hip >= 45 ||
        bodyData.arm < 21.5 ||
        bodyData.arm >= 28.5 ||
        bodyData.leg < 28 ||
        bodyData.leg >= 35
      ) {
        setAlert(true);
        setAlertMessage("유효범위를 입력해주세요.");
        return;
      }
    }

    const getCalculate = async () => {
      setLoading(true);
      const BodyCalculate = await Api.get(
        `/Consult/getBodyCalculate?sex=${bodyData.sex}&height=${bodyData.height}&shoulder=${bodyData.shoulder}&chest=${bodyData.chest}&waist=${bodyData.waist}&hip=${bodyData.hip}&arm=${bodyData.arm}&leg=${bodyData.leg}`
      );
      setLoading(false);
      if (BodyCalculate != undefined) {
        setBodyResult(BodyCalculate[0]);
        setCalculate(true);
      }
    };

    getCalculate();
  };

  const changeTextField = (value: any) => {
    if (value.name == "height") {
      setBodyData((prev: any) => ({
        ...prev,
        height: value.value,
      }));
    } else if (value.name == "shoulder") {
      setBodyData((prev: any) => ({
        ...prev,
        shoulder: value.value,
      }));
    } else if (value.name == "chest") {
      setBodyData((prev: any) => ({
        ...prev,
        chest: value.value,
      }));
    } else if (value.name == "waist") {
      setBodyData((prev: any) => ({
        ...prev,
        waist: value.value,
      }));
    } else if (value.name == "hip") {
      setBodyData((prev: any) => ({
        ...prev,
        hip: value.value,
      }));
    } else if (value.name == "arm") {
      setBodyData((prev: any) => ({
        ...prev,
        arm: value.value,
      }));
    } else if (value.name == "leg") {
      setBodyData((prev: any) => ({
        ...prev,
        leg: value.value,
      }));
    }
  };
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box className="BodySizeModalBox">
        {props.state != "view" && (
          <Box className="ConsultDetailForm">
            <Title level={4} className="ConsultDetailName">
              신장
            </Title>
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.height}
                name="height"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    cm
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 145이상 ~ 180미만/ (남성) 160이상 ~ 195미만
              </Title>
            </Box>
          </Box>
        )}

        <Box className="ConsultDetailForm">
          <Title level={4} className="ConsultDetailName">
            어깨너비
          </Title>
          {props.state == "view" ? (
            <Title level={5} className="ConsultDetailName">
              <ArrowForwardIos fontSize="small" className="ConsultAnswerIcon" />
              {BodyResult.shoulder} inch
            </Title>
          ) : (
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.shoulder}
                name="shoulder"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    inch
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 13이상 ~ 19.75미만/ (남성) 15.25이상 ~
                20.25미만
              </Title>
            </Box>
          )}
        </Box>
        <Box className="ConsultDetailForm">
          <Title level={4} className="ConsultDetailName">
            가슴둘레
          </Title>
          {props.state == "view" ? (
            <Title level={5} className="ConsultDetailName">
              <ArrowForwardIos fontSize="small" className="ConsultAnswerIcon" />
              {BodyResult.chest} inch
            </Title>
          ) : (
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.chest}
                name="chest"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    inch
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 29이상 ~ 44.5미만/ (남성) 31이상 ~ 45미만
              </Title>
            </Box>
          )}
        </Box>
        <Box className="ConsultDetailForm">
          <Title level={4} className="ConsultDetailName">
            허리둘레
          </Title>
          {props.state == "view" ? (
            <Title level={5} className="ConsultDetailName">
              <ArrowForwardIos fontSize="small" className="ConsultAnswerIcon" />
              {BodyResult.waist} inch
            </Title>
          ) : (
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.waist}
                name="waist"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    inch
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 22이상 ~ 37.5미만/ (남성) 25이상 ~ 39.5미만
              </Title>
            </Box>
          )}
        </Box>
        <Box className="ConsultDetailForm">
          <Title level={4} className="ConsultDetailName">
            힙둘레
          </Title>
          {props.state == "view" ? (
            <Title level={5} className="ConsultDetailName">
              <ArrowForwardIos fontSize="small" className="ConsultAnswerIcon" />
              {BodyResult.hip} inch
            </Title>
          ) : (
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.hip}
                name="hip"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    inch
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 32이상 ~ 47.5미만/ (남성) 31이상 ~ 45미만
              </Title>
            </Box>
          )}
        </Box>

        {props.state != "view" && (
          <Box className="ConsultDetailForm">
            <Title level={4} className="ConsultDetailName">
              팔(소매) 길이
            </Title>
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.arm}
                name="arm"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    inch
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 19이상 ~ 26미만/ (남성) 21.5이상 ~ 28.5미만
              </Title>
            </Box>
          </Box>
        )}

        {props.state != "view" && (
          <Box className="ConsultDetailForm">
            <Title level={4} className="ConsultDetailName">
              다리 길이
            </Title>
            <Box>
              <TextComponent
                variant="standard"
                value={bodyData.leg}
                name="leg"
                fullWidth
                onChange={changeTextField}
                type="number"
                disabled={calculate}
                endAdornment={
                  <Title level={5} className="ConsultDetailName">
                    inch
                  </Title>
                }
              />
              <Title level={5} className="ConsultDetailName">
                * 유효범위: (여성) 25.5이상 ~ 32.5미만/ (남성) 28이상 ~ 35미만
              </Title>
            </Box>
          </Box>
        )}

        {(calculate || props.state == "view") && (
          <>
            <Divider />
            <Box className="ConsultDetailForm">
              <Title level={4} className="ConsultDetailName">
                * 측정 결과
              </Title>
              <div style={{ width: "100%" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "center",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                          backgroundColor: "#BFDBFE", // 소매판정 헤더 배경
                          fontWeight: 700,
                        }}
                      >
                        소매판정
                      </th>
                      <th
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                          backgroundColor: "#BFDBFE", // 다리판정 헤더 배경
                          fontWeight: 700,
                        }}
                      >
                        다리판정
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                        }}
                      >
                        {BodyResult.arm === "S"
                          ? "평균이하"
                          : BodyResult.arm === "N"
                          ? "평균"
                          : "평균이상"}
                      </td>
                      <td
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                        }}
                      >
                        {BodyResult.leg === "S"
                          ? "평균이하"
                          : BodyResult.leg === "N"
                          ? "평균"
                          : "평균이상"}
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                          backgroundColor: "#BBF7D0", // TYPE1 배경
                          fontWeight: 600,
                        }}
                      >
                        TYPE1
                      </td>
                      <td
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                          backgroundColor: "#BBF7D0", // TYPE2 배경
                          fontWeight: 600,
                        }}
                      >
                        TYPE2
                      </td>
                    </tr>

                    <tr>
                      <td
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                        }}
                      >
                        {BodyResult.type1}
                      </td>
                      <td
                        style={{
                          border: "1px solid #D1D5DB",
                          padding: "12px 16px",
                        }}
                      >
                        {BodyResult.type2}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Box>
          </>
        )}
        <div className="BodySizeModalBottom">
          {props.state != "view" &&
            (calculate ? (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => props.onClose(BodyResult)}
                className="BodySizeModalUpdateButton"
              >
                저장
              </ButtonComponent>
            ) : (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => handlecalculate()}
                className="BodySizeModalButton"
              >
                계산하기
              </ButtonComponent>
            ))}
          {props.cancel && (
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => props.onClose(false)}
              className="BodySizeModalButton"
            >
              취소
            </ButtonComponent>
          )}
        </div>
        {alert && (
          <AlertComponent value={alert} setValue={setAlert} info="error">
            {alertMessage}
          </AlertComponent>
        )}
        {loading && <Loading />}
      </Box>
    </Modal>
  );
}
